import { IInhouseCategory } from './types';

// Fallback categories used until dynamic ones are loaded
export const INHOUSE_CATEGORIES: IInhouseCategory[] = [
  { id: 'saljblad', label: 'Säljblad', color: '#2196F3' },
  { id: 'film', label: 'Film / Video', color: '#E91E63' },
  { id: 'produktetikett', label: 'Produktetiketter', color: '#FF9800' },
  { id: 'some', label: 'Social Media', color: '#9C27B0' },
  { id: 'kampanj', label: 'Kampanj', color: '#F44336' },
  { id: 'grafisk', label: 'Grafisk profil', color: '#009688' },
  { id: 'webb', label: 'Webb', color: '#3F51B5' },
  { id: 'ovriga', label: 'Övrigt', color: '#607D8B' },
];

export function getCategoryByIdFromList(categories: IInhouseCategory[], id: string): IInhouseCategory | undefined {
  return categories.find(c => c.id === id);
}

export function getCategoryById(id: string): IInhouseCategory | undefined {
  return INHOUSE_CATEGORIES.find(c => c.id === id);
}

export function getCategoryColor(id: string): string {
  return getCategoryById(id)?.color || '#607D8B';
}

export function getCategoryLabel(id: string): string {
  return getCategoryById(id)?.label || id;
}

// Reaction emoji mapping — single heart like Instagram
export const REACTION_EMOJIS: Record<string, string> = {
  heart: '❤️',
};

export const REACTION_TYPES = Object.keys(REACTION_EMOJIS);
